import { gql } from '@apollo/client';

export const CHANGE_USERS_ROLE = gql`
  mutation changeUsersRole($agencyId: Int!, $userId: Int!, $role: String!) {
    changeUsersRole(agencyId: $agencyId, userId: $userId, role: $role)
  }
`;
